import FileValidatorConfig from 'features/validation/models/FileValidatorConfig';

export default class FileValidator {
  private readonly _fileValidatorConfig: FileValidatorConfig;

  constructor(fileValidatorConfig: FileValidatorConfig) {
    this._fileValidatorConfig = fileValidatorConfig;
  }

  validate(file: File): boolean {
    if (!this.validateFileSize(file)) {
      return false;
    }

    if (!this.validateFileExtension(file)) {
      return false;
    }

    return true;
  }

  validateMultiple(files: FileList): boolean {
    if (files.length > this._fileValidatorConfig.maxFilesCount) {
      return false;
    }

    let total = 0;

    for (let i = 0; i < files.length; i++) {
      let file = files[i];

      if (!this.validate(file)) {
        return false;
      }

      total += file.size;
    }

		return total <= (this._fileValidatorConfig.maxFilesSizeInMb * 1024.0 * 1024.0);
  }

  private validateFileSize(file: File): boolean {
    return file.size <= (this._fileValidatorConfig.maxFileSizeInMb * 1024.0 * 1024.0);
  }

  private validateFileExtension(file: File): boolean {
    let extension = file.name.split('.').pop();

    if (extension) {
      extension = `.${extension}`;

      return this._fileValidatorConfig.enabledExtensions.includes(extension);
    }

    return false;
  }
}